module.exports = {
        srcSet: __webpack_public_path__ + "static/media/download-664.a087469c.webp"+" 664w",
        images: [{path: __webpack_public_path__ + "static/media/download-664.a087469c.webp",width: 664,height: 664}],
        src: __webpack_public_path__ + "static/media/download-664.a087469c.webp",
        toString: function(){return __webpack_public_path__ + "static/media/download-664.a087469c.webp"},
        
        width: 664,
        height: 664
      }